module.exports = __webpack_public_path__ + "img/historytitle.5dce72ca.png";